exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-box.style5>i[data-v-06eb48c7]{background:#ec008b}.icon-box.style5[data-v-06eb48c7]{background:#f5f5f5}.alert.alert-help[data-v-06eb48c7]{background:#dcecf6;color:#406f8c}.alert .close[data-v-06eb48c7],.info-box .close[data-v-06eb48c7]{color:#406f8c}.icon-check-srvcs[data-v-06eb48c7]{position:relative;padding-right:30px!important;padding-left:0!important;overflow:hidden}.icon-check-srvcs[data-v-06eb48c7]:after{content:\"\";position:absolute;top:0;right:0;width:30px;height:100%;background:url(/res/images/icon/icon-check.png) no-repeat 50% #4a6e89}.errormsg[data-v-06eb48c7]{margin-bottom:3px;margin-top:3px;color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06eb48c7","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/forms/BookingnoTab.vue
// module id = 375
// module chunks = 0